// Sub-company-target loan actions — maps the four sub-company action subtypes and the
// SendEmailTemplate SubCompanyRecipients addition between the loan-action form shape and the API
// shape. The backend LoanActionType subtypes are AssignSubCompanyAe(AeUserId),
// DecideCertification(Decision, Reason), ExecuteAiProcess(ProcessId, IncludeActiveCertification),
// and StartCertificationCycle (no payload — handled by the caller's no-payload path). Extracted
// from LoanActionTransformations.utils.js to keep that file within the max-lines budget.

import {
  certificationDecisionOptions,
  LoanEditorActionsEnum,
  SubCompanyRecipientModeEnum,
  subCompanyRecipientModeOptions,
} from 'constants/loanActionEditor';

export const getSubCompanyRecipientsApiFormat = subCompanyRecipients => {
  if (!subCompanyRecipients?.mode) {
    return null;
  }

  const modeValue = subCompanyRecipients.mode.value;

  return {
    mode: modeValue,
    roleId:
      modeValue === SubCompanyRecipientModeEnum.ROLE
        ? (subCompanyRecipients.role?.value ?? null)
        : null,
  };
};

export const getSubCompanyRecipientsFormFormat = (apiRecipients, securityGroupOptions = []) => {
  if (!apiRecipients) {
    return null;
  }

  return {
    mode: subCompanyRecipientModeOptions.find(({ value }) => value === apiRecipients.mode) ?? null,
    role: apiRecipients.roleId
      ? (securityGroupOptions.find(({ value }) => value === apiRecipients.roleId) ?? null)
      : null,
  };
};

export const getSubCompanyActionApiFormat = ({ type, formItem, common }) => {
  switch (type) {
    case LoanEditorActionsEnum.ASSIGN_SUB_COMPANY_AE:
      return { ...common, aeUserId: formItem.assignSubCompanyAe[0].aeUser?.value };

    case LoanEditorActionsEnum.DECIDE_CERTIFICATION: {
      const { decision, reason } = formItem.decideCertification[0];

      return { ...common, decision: decision?.value, reason: reason?.trim() || null };
    }

    case LoanEditorActionsEnum.EXECUTE_AI_PROCESS: {
      const { processId, includeActiveCertification } = formItem.executeAiProcess[0];

      return {
        ...common,
        processId: processId?.trim(),
        includeActiveCertification: !!includeActiveCertification,
      };
    }

    default:
      return common;
  }
};

export const getSubCompanyActionFormFormat = ({
  type,
  actionItem,
  itemType,
  timedSequenceOptions,
  usersOptions = [],
}) => {
  switch (type) {
    case LoanEditorActionsEnum.ASSIGN_SUB_COMPANY_AE: {
      const aeUser = usersOptions.find(({ value }) => value === actionItem.aeUserId) ?? null;

      return { itemType, timedSequenceOptions, assignSubCompanyAe: [{ aeUser }] };
    }

    case LoanEditorActionsEnum.DECIDE_CERTIFICATION: {
      const decision =
        certificationDecisionOptions.find(({ value }) => value === actionItem.decision) ?? null;

      return {
        itemType,
        timedSequenceOptions,
        decideCertification: [{ decision, reason: actionItem.reason || '' }],
      };
    }

    case LoanEditorActionsEnum.EXECUTE_AI_PROCESS:
      return {
        itemType,
        timedSequenceOptions,
        executeAiProcess: [
          {
            processId: actionItem.processId || '',
            includeActiveCertification: !!actionItem.includeActiveCertification,
          },
        ],
      };

    default:
      return { itemType, timedSequenceOptions };
  }
};
